import { render, staticRenderFns } from "./resumen-observaciones.vue?vue&type=template&id=a66d4a4e&scoped=true&"
import script from "./resumen-observaciones.vue?vue&type=script&lang=ts&"
export * from "./resumen-observaciones.vue?vue&type=script&lang=ts&"
import style0 from "./resumen-observaciones.vue?vue&type=style&index=0&id=a66d4a4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66d4a4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VCol,VProgressCircular,VRow,VSkeletonLoader,VSpacer,VTextField})
